// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"fdf3f578","320":"b1132189","402":"531c4105","793":"770e1d0b"}[chunkId] + ".chunk.js";
};